export default __webpack_public_path__ + "static/multiplan-2f1260962154cf853f736095cf181a33.svg";